<template lang='pug'>
div(:class='$style[`cc-question-sub-reply-brief`]')
  div(:class='$style[`cc-question-sub-reply-brief-left`]')
    router-link(
      role='button'
      tabindex='0'
      aria-label='查看個人檔案'
      :class='$style[`cc-question-sub-reply-avatar`]'
      :to='{ name: `profile-detail`, params: { type: `${subReplyBriefData.user_type}`, id: `${subReplyBriefData.auth_id}` }}')
      div(v-if='subReplyBriefData.user_type === `doctor`' :class='$style[`cc-reply-avatar`]')
        figure(v-if='subReplyBriefData.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
          //- Doctor-Male-Avatar
          img(
            v-if='subReplyBriefData.gender === `0`'
            :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
            width='100%'
            height='100%')
          //- Doctor-Female-Avatar
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(subReplyBriefData.thumbSrc)'
            width='100%'
            height='100%')


      div(v-if='subReplyBriefData.user_type === `normal`' :class='$style[`cc-reply-avatar`]')
        figure(v-if='subReplyBriefData.thumbSrc === `` && !subReplyBriefData.public' :class='$style[`cc-avatar-photo`]')
          img(
            v-if='subReplyBriefData.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')


        figure(v-else-if='subReplyBriefData.thumbSrc !== `` && !subReplyBriefData.public' :class='$style[`cc-avatar-photo`]')
          img(
            v-if='subReplyBriefData.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='subReplyBriefData.thumbSrc === `` && subReplyBriefData.public' :class='$style[`cc-avatar-photo`]')
          img(
            v-if='subReplyBriefData.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')

        figure(v-else-if='subReplyBriefData.thumbSrc !== `` && subReplyBriefData.public' :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(subReplyBriefData.thumbSrc)'
            width='100%'
            height='100%')


  div(:class='$style[`cc-question-sub-reply-brief-right`]')
    div(:class='$style[`cc-question-li-right-message`]')
      div(v-if='loginStatus && subReplyBriefData.auth_id === `${loginDjangoId}`' :class='$style[`cc-question-li-right-delete`]' @click='handleClickKillSubReply(subReplyBriefData.id, subReplyBriefData.auth_id)')
      div(:class='$style[`cc-question-li-right-panel`]')
        router-link(
          v-if='subReplyBriefData.user_type === `doctor`'
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-question-li-right-name`]'
          :to='{ name: `profile-detail`, params: { type: `doctor`, id: `${subReplyBriefData.auth_id}` }}')
          span.font-medium.font-doctor-theme {{ `${subReplyBriefData.firstName}${subReplyBriefData.lastName}` }}
            //- span {{ `編號${subReplyBriefData.auth_id}`}}
        router-link(
          v-else
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-question-li-right-name`]'
          :to='{ name: `profile-detail`, params: { type: `normal`, id: `${subReplyBriefData.auth_id}` }}')
          span.font-medium.font-normal-theme(v-if='!subReplyBriefData.public') {{ `${subReplyBriefData.firstName}${subReplyBriefData.gender === `0` ? `先生` : `小姐`}` }}
          span.font-medium.font-normal-theme(v-else) {{ `${subReplyBriefData.firstName}${subReplyBriefData.lastName}` }}

        div(:class='$style[`cc-question-li-right-date`]') {{ subReplyBriefData.date }}

      span(
        v-if='subReplyBriefData.reply && needCollapse'
        :class='$style[`cc-question-li-right-comment`]') {{ ellipseQaSubReply(subReplyBriefData.reply) }}

        span(:class='$style[`cc-question-reply-collapse`]' @click='handleClickCloseCollapse')
          IconOpenArrow(:size='12' :color='`#98a1a1`')
          != '看全部'
      span(v-else-if='subReplyBriefData.reply' :class='$style[`cc-question-li-right-comment`]') {{ subReplyBriefData.reply }}



</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconOpenArrow from '../../icon/OpenArrow';
// import IconDialog from '../../icon/Dialog';
// import { debounce } from 'debounce';

export default {
  components: {
    IconOpenArrow,
  },

  props: {
    subReplyBriefData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      needCollapse: false,
    };
  },

  created() {
    this.ellipseQaSubReply(this.subReplyBriefData.reply);
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDeleteReplyStatus: 'global/POPDELETE_REPLY_STATUS',
    }),

    ellipseQaSubReply(text) {
      if (text.length > 200) {
        this.needCollapse = true;
        return `${text.substring(0, 200)}...`;
      }
      return text;
    },

    handleClickCloseCollapse() {
      this.needCollapse = false;
    },

    // axiosLoadSubReplyData(pageIndex) {
    //   const PASS_DATA = {
    //     size: `${this.limitNum}`,
    //     page: `${pageIndex}`,
    //     q_id: `${this.qid}`,
    //     aaid: `${this.aaid}`,
    //   };

    //   putQaSubReplyList('', PASS_DATA)
    //     .then((res) => {
    //       const subReplyRes = res.data;
    //       subReplyRes.results.map((x) => this.subReplyData.push(x));

    //       if (subReplyRes.length === 0) {
    //         console.log('SubReply 抓不到文章資料');
    //         // lazyState.complete();
    //         this.showLoadMore = false;
    //       } else if (subReplyRes.length < this.limitCount || this.subReplyData.length === subReplyRes.count) {
    //         console.log(`SubReply到底 ${this.pageIndex}`);
    //         this.showLoadMore = false;
    //       } else {
    //         console.log('SubReply還有');
    //       }
    //     })
    //     .catch((err) => {
    //       console.log('Axios putQaReplyList Error');
    //     });
    // },

    handleClickKillSubReply(qid, remindId) {
      console.log('handleClickKillSubReply');
      this.changePopDeleteReplyStatus({
        active: true,
        aaId: `${qid}`,
        remindId: `${remindId}`,
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginStatus: 'user/exportLoginStatus',
      loginDjangoId: 'user/exportUserDjangoId',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/qa/questionSubReplyBrief.scss';
</style>
